import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type Payload = {
  vehicleId: string
  copies: number
}

/**
 * Clone one vehicle, n times where n = copies
 *
 * @private
 */
export const cloneVehicleMultipleCopies = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/vehicle/cloneVehicleMultipleCopies', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/vehicle/cloneMultipleCopies', {
      category: 'rpc',
      type: 'rpc/vehicle/cloneMultipleCopies',
      vehicleId: payload.vehicleId,
      copies: payload.copies,
    })
    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {cloneVehicleMultipleCopies}`,
      { tags: ['rpc', 'vehicles'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Clone vehicles failed`,
      error,
    })
  }
})
